import { render, staticRenderFns } from "./NotificationPopup.vue?vue&type=template&id=4a1f41be&scoped=true&lang=pug&"
import script from "./NotificationPopup.vue?vue&type=script&lang=js&"
export * from "./NotificationPopup.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPopup.vue?vue&type=style&index=0&id=4a1f41be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1f41be",
  null
  
)

export default component.exports